import React,{useState,useRef,useEffect,useCallback} from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { NavBar,Popup,CheckList,setDefaultConfig } from 'antd-mobile';
import type { CheckListValue } from 'antd-mobile/es/components/check-list';
import zhCN from 'antd-mobile/es/locales/zh-CN';
import enUS from 'antd-mobile/es/locales/en-US';
import jaJP from 'antd-mobile/es/locales/ja-JP';

interface LanguagesProps {
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const languageList = [{name:"English",value:'en'},{name:"中文",value:'zh'},{name:"日本語",value:'jp'}];

const Languages=({visible, setVisible}: LanguagesProps)=> {
    const { t,i18n } = useTranslation();
	
    const handleBack=()=>{
        setVisible(false);
    }
    const handleChange=async (value: CheckListValue[])=>{
        type AntdLocale = {
            en: typeof enUS;
            zh: typeof zhCN;
            jp: typeof jaJP;
        }
        const antdMLang: AntdLocale={en:enUS,zh:zhCN,jp:jaJP};
        let storage = window.localStorage;
        localStorage.lang=value;
		//@ts-ignore
        await i18n.changeLanguage(value);
        if(value && value[0]) setDefaultConfig({locale: antdMLang[value[0] as keyof typeof antdMLang]});
        setVisible(false)
    }

    return (
        <Popup
            visible={visible}
            onMaskClick={() => {
                setVisible(false)
            }}
            position='right'
            bodyStyle={{ width: '100%',backgroundColor:'#0d0d0d' }}
            className={styles.languagePopup}
        >
            <div className={styles.languageCont}>
                <NavBar onBack={handleBack} style={{'--height': '70px'}}>{t('language')}</NavBar>
                <div className={styles.languageMain}>
                    <div className={styles.list}>
                        <CheckList value={[i18n.language]} onChange={handleChange}>
                            {languageList.map((item, index) => (
                                <CheckList.Item key={index} value={item.value}>{item.name}</CheckList.Item>
                            ))}
                        </CheckList>
                    </div>
                </div>
            </div>
        </Popup>
    )
}
export default Languages;